module.exports = __webpack_public_path__ + "img/advisor-partner.eea5624e.jpeg";